var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 66,
    viewBox: "0 0 97 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3065_205951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79233 57.4315L25.384 62.4259L23.9543 57.9144C32.6344 54.4752 68.3496 38.3464 85.4226 -0.00211351C85.4226 -0.00211351 62.1449 36.355 20.659 47.5152L19.1142 42.6397L9.79233 57.4315Z",
    fill: "#2275EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3065_205951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.9182,
    height: 44.7617,
    fill: "white",
    transform: "translate(97.0078 43.2344) rotate(165)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertArrow);
export default __webpack_public_path__ + "static/media/expertArrow.d53da7192c59904ad77cef8f95775a26.svg";
export { ForwardRef as ReactComponent };